// ChartVoiceButton.jsx — floating mic button for the chart toolbar.
// Replaces the previous stub (browser speechSynthesis + alert) with the real orchestrator.

import React from "react";
import { useChartVoice } from "./useChartVoice";

export default function ChartVoiceButton({
  voiceRef, symbol, onSetSymbol, onSetTimeframe,
  onRunAnalyze, onRunFindTrade, onTrade, onCloseSymbol, onCloseAll, onClearIndicators,
  onSpeak,
}) {
  const { voiceState, toggle } = useChartVoice({
    voiceRef, symbol, onSetSymbol, onSetTimeframe,
    onRunAnalyze, onRunFindTrade, onTrade, onCloseSymbol, onCloseAll, onClearIndicators,
    onSpeak,
  });

  const color = voiceState === "recording" ? "#ef4444"
              : voiceState === "processing" ? "#f59e0b"
              : voiceState === "denied" ? "#7f1d1d"
              : "#00d4aa";

  const label = voiceState === "recording" ? "⏹ Stop Voice"
              : voiceState === "processing" ? "⏳ Listening..."
              : voiceState === "denied" ? "🚫 Mic blocked"
              : "🎤 Voice AI";

  const title = voiceState === "recording"
    ? "Click to stop voice control. Say: switch to R 25, add RSI, find a trade, buy, sell, close all, zoom in, fit chart, fullscreen, analyze, conditions."
    : voiceState === "denied"
    ? "Microphone access blocked. Click to retry."
    : "Voice control: say 'switch to R 25', 'add RSI', 'one minute', 'find a trade', 'buy', 'sell', 'close all', 'zoom in', 'analyze'.";

  return (
    <button
      onClick={toggle}
      title={title}
      style={{
        background: voiceState === "recording" ? "#2d1060" : voiceState === "denied" ? "#2d0a0a" : "#0d1f35",
        color,
        border: `1px solid ${color}66`,
        borderRadius: 4,
        padding: "4px 10px",
        cursor: "pointer",
        fontSize: 12,
        fontWeight: 600,
        animation: voiceState === "recording" ? "pulse 0.8s infinite" : "none",
        fontFamily: "inherit",
      }}
    >
      {label}
    </button>
  );
}
